import { OrientationProps } from '../@types/MenuProps';

type MenuContainerProps = {
	children: React.ReactNode;
	orientation?: OrientationProps;
	blockClass?: string;
};

const MenuContainer = ({ children, orientation, blockClass }: MenuContainerProps) => {
	const renderTokens = (): string => {
		if (orientation === 'vertical') {
			return 'list flex pl0 mv0 flex-column';
		}

		return 'list flex pl0 mv0 flex-row';
	};

	return (
		<ul
			className={`vtex-menu-2-x-menuContainer menuContainer vtex-menu-2-x-menuContainer--${blockClass} menuContainer--${blockClass} ${renderTokens()}`}
		>
			{children}
		</ul>
	);
};

export default MenuContainer;
